import { Component, DestroyRef, Inject, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OnboardingFinishResolve, SignupParkingSession } from '@shared/models';
import { FeatureFlagService } from '@core/services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TypedRoute } from '@shared/utils';

@Component({
  selector: 'app-onboarding-finish',
  templateUrl: './onboarding-finish.component.html',
  styleUrl: './onboarding-finish.component.scss',
})
export class OnboardingFinishComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  parkingSession: SignupParkingSession | null = null;

  showParkingSessionOverview: boolean = true;
  appAndNotificationsEnabled!: boolean;

  constructor(
    @Inject(ActivatedRoute) private route: TypedRoute<OnboardingFinishResolve>,
    private featureFlagService: FeatureFlagService,
  ) {
    this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.parkingSession = data.signupSummaryApiResolve.onboarding_parking_session;

      if (!this.parkingSession) {
        this.showParkingSessionOverview = false;
      }
    });
  }

  ngOnInit() {
    this.appAndNotificationsEnabled = this.featureFlagService.getFeatureFlag('enable_app_and_notifications');
  }
}
